import Profile from './profile.i18n';

export default Profile
export { Profile as Base }